import React, { Component } from 'react';
import MyMessage from "../../../components/Message/index";

const pStyle = {
  textAlign: 'center',
  color: 'green',
  display: 'inline'
};

export default class MessageSuccess extends Component {
  render() {
    return (
      <MyMessage textAlign={this.props.textAlign} style={pStyle} message={this.props.message} icon={this.props.icon} iconName='checkmark'/>
    );
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/MessageSuccess/index.js